/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PageDataOrderBigTablePageResVo } from './PageDataOrderBigTablePageResVo';
import {
    PageDataOrderBigTablePageResVoFromJSON,
    PageDataOrderBigTablePageResVoFromJSONTyped,
    PageDataOrderBigTablePageResVoToJSON,
    PageDataOrderBigTablePageResVoToJSONTyped,
} from './PageDataOrderBigTablePageResVo';

/**
 * 
 * @export
 * @interface ResponsePageDataOrderBigTablePageResVo
 */
export interface ResponsePageDataOrderBigTablePageResVo {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponsePageDataOrderBigTablePageResVo
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponsePageDataOrderBigTablePageResVo
     */
    message?: string;
    /**
     * 
     * @type {PageDataOrderBigTablePageResVo}
     * @memberof ResponsePageDataOrderBigTablePageResVo
     */
    data?: PageDataOrderBigTablePageResVo;
}

/**
 * Check if a given object implements the ResponsePageDataOrderBigTablePageResVo interface.
 */
export function instanceOfResponsePageDataOrderBigTablePageResVo(value: object): value is ResponsePageDataOrderBigTablePageResVo {
    return true;
}

export function ResponsePageDataOrderBigTablePageResVoFromJSON(json: any): ResponsePageDataOrderBigTablePageResVo {
    return ResponsePageDataOrderBigTablePageResVoFromJSONTyped(json, false);
}

export function ResponsePageDataOrderBigTablePageResVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponsePageDataOrderBigTablePageResVo {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : PageDataOrderBigTablePageResVoFromJSON(json['data']),
    };
}

export function ResponsePageDataOrderBigTablePageResVoToJSON(json: any): ResponsePageDataOrderBigTablePageResVo {
    return ResponsePageDataOrderBigTablePageResVoToJSONTyped(json, false);
}

export function ResponsePageDataOrderBigTablePageResVoToJSONTyped(value?: ResponsePageDataOrderBigTablePageResVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': PageDataOrderBigTablePageResVoToJSON(value['data']),
    };
}

